// extracted by mini-css-extract-plugin
export var nav = "mainnav-module--nav--1hI0L";